// Wortlaute der Erklärung „Maschinen“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Reiter und Felder stehen so, wie die Maschinenseite sie zeigt (../machine.js).
// Zwillingsdatei: help/materials.js. Was hier geändert wird, gehört fast immer auch dorthin.
export default {
  title: "Maschinen",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    MachineOverview: "Übersicht",
    MachineDetail: "Maschine",
    CustomerDetail: "Kundenpreise",
    PacketDetail: "Paket",
    ProjectDetail: "Projekt",
    ProjectCostsForOne: "Projektkosten",
  },
  // Die Seiten außerhalb des Katalogs, in denen eine Maschine wirkt. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    list: {
      text: "Hier steht der Maschinenpark Ihres Betriebs. Ein Klick auf eine Zeile öffnet die Maschine.",
    },
    row: {
      text: "Die Zeile zeigt Bezeichnung, Einkaufspreis je Einheit und wann die Maschine zuletzt geändert wurde.",
    },
    create: {
      text: "Neu anlegen bietet beides an: Neue Maschine erstellen öffnet das leere Formular. Es braucht Bezeichnung und Einheit.",
    },
    "kind-filter": {
      text: "Maschinen und Pakete stehen in einer Tabelle, der Filter darüber zeigt nur eines von beiden. Ein Paket bündelt mehrere Maschinen für Projekt und Kunde.",
    },
    head: {
      text: "Der Kopf trägt Symbol und Namen der Maschine. Rechts stehen die Aktionen zu diesem Datensatz.",
    },
    "action-duplicate": {
      text: "Duplizieren öffnet eine neue Maschine mit denselben Angaben und Preisen. Sie ändern nur, was anders ist, und speichern.",
    },
    "action-packet": {
      text: "Paket daraus erstellen legt ein neues Paket an. Diese Maschine steht darin schon als erste Position.",
    },
    tabs: {
      text: "Die Reiter teilen die Seite auf. Welcher Reiter offen ist, steht in der Adresse der Seite.",
    },
    base: {
      text: "Bezeichnung, Abrechnungseinheit und Transportgewicht sind die Stammdaten. Die Einheit ist Stunde oder Tag, das Transportgewicht wählt beim Mietlieferanten die Transportklasse.",
    },
    purchase: {
      text: "Der Einkaufspreis gilt je Einheit. Wer bei verschiedenen Lieferanten unterschiedlich viel zahlt, legt mehrere Einkaufspreise mit Bezeichnung an; einer davon ist der Standard. Jeder Preis wählt seine eigene Währung, ein Projekt rechnet nur mit dem Preis in seiner Währung.",
    },
    note: {
      text: "Die Notiz ist für den internen Hinweis. Sie gehört zur Maschine und nicht zu einem einzelnen Projekt.",
    },
    // Der Reiter Einkauf, sobald die Einkaufspreise Lieferanten gehören (docs/suppliers.md).
    "purchase-tab": {
      text: "Im Reiter Einkauf steht jeder Lieferant, bei dem es diese Maschine gibt. Seine Preise ändern Sie beim Lieferanten im Sortiment.",
    },
    "purchase-history": {
      text: "Der Kopf nennt, was die Maschine in der Regel kostet: den Preis des Standard-Lieferanten und die Spanne über alle. Aufgeklappt zeigt der Preisverlauf jeden Preis über die Monate, rechts von Heute die schon feststehenden.",
    },
    "purchase-rows": {
      text: "Je Lieferant steht hier der Preis von heute und, wo schon eingetragen, der nächste. Abstand misst ihn am Standard, und der Name öffnet das Sortiment des Lieferanten.",
    },
    // Eine Zeile in einer anderen Einheit als die Maschine (Mietpark Nord je Woche).
    "purchase-unit": {
      text: "Ein Lieferant kann je Woche oder Monat abrechnen, auch wenn die Maschine je Stunde verkauft wird. Der Preis nennt seine Einheit; Abstand vergleicht Tag, Woche und Monat je Tag, eine Stunde nur mit Stunden.",
    },
    // Die Zeile unter Mietpark Nord: sein Transporttarif in der Klasse des Minibaggers.
    "purchase-transport": {
      text: "Darunter steht der Transport des Lieferanten in der Klasse, die das Transportgewicht der Maschine wählt. Den Tarif pflegen Sie in seinen Konditionen.",
    },
    "purchase-accessories": {
      text: "Darunter das Zubehör, das der Lieferant zu dieser Maschine vermietet, etwa einen Tieflöffel, mit Preis je Tag oder Woche. Neues fügen Sie im Menü ⋮ der Zeile hinzu; an einer Miete im Projekt nehmen Sie es mit.",
    },
    "purchase-default": {
      text: "Standard ist der Preis, mit dem ein Projekt die Maschine übernimmt. Ein Klick bei einem anderen Lieferanten macht ihn zum Standard, sofort und ohne Speichern.",
    },
    "purchase-change": {
      text: "Der Stift ändert den Preis eines Lieferanten: neuer Betrag und der Tag, ab dem er gilt, auch rückwirkend. Der alte Preis bleibt im Verlauf.",
    },
    "purchase-quantity": {
      text: "Mit einer Vergleichsmenge, hier einer Dauer, rechnet die Spalte Frei Baustelle Rabatt und Skonto ein, der Transport kommt dazu. Der günstigste Preis steht fett und grün, auch wenn sein Listenpreis höher ist.",
    },
    "purchase-add": {
      text: "Preis hinzufügen nimmt den Preis eines weiteren Lieferanten auf. Der erste wird zum Standard.",
    },
    "purchase-following": {
      text: "Nach einer rückwirkenden Änderung bleiben Buchungen der Projekte beim alten Preis. Umstellen bringt sie auf den Preis ihres Tages.",
    },
    files: {
      text: "In die Dateiablage legen Sie Betriebsanleitungen und Prüfprotokolle. Ein Ablaufdatum färbt sich, sobald es näher kommt.",
    },
    activity: {
      text: "Das Protokoll zeigt jede Änderung mit Tag und Person. Unter Verweise steht, wo diese Maschine verwendet wird.",
    },
    save: {
      text: "Speichern schreibt alle Reiter auf einmal. Ein Reiter mit einem Fehler wird dabei nach vorn geholt.",
    },
    comparison: {
      text: "Über Aktionen und Vergleichen stellen Sie zwei Maschinen nebeneinander. Die Zeilen sind die Lieferanten, die beide vermieten. Der günstigere Preis steht fett und grün.",
    },
    "comparison-pick": {
      text: "Oben in jeder Karte wählen Sie die Maschine. Darunter stehen ihr üblicher Preis und bei wie vielen Lieferanten sie die günstigere ist.",
    },
    "comparison-only": {
      text: "Lieferanten, die nur eine der beiden haben, stehen zugeklappt unter ihrer Karte.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut.",
    },
    // Zusammenhänge: was die Maschine außerhalb des Katalogs bewirkt.
    "customer-price": {
      text: "Für einen Kunden hinterlegen Sie einen eigenen Verkaufspreis. Ein Festpreis darf auch pro Tag gelten, wenn die Maschine pro Stunde kostet.",
    },
    "packet-items": {
      text: "Ein Paket bündelt mehrere Maschinen. Ein Projekt oder ein Kunde übernimmt sie damit in einem Schritt.",
    },
    "project-machines": {
      text: "Im Projekt steht neben dem Einkaufspreis der Verkaufspreis. Kosten und Erlös rechnen die Einsatzzeit jeweils in ihre eigene Einheit um.",
    },
    "project-report": {
      text: "Gebucht wird die Maschine im Reiter Maschinen [[hwr:eines/einer/eines]] [[hwr.gen]], je Gerät mit Geräte-Nummer und Stunden. Ein Tagessatz zählt jeden angefangenen Einsatztag.",
    },
    "project-costs": {
      text: "Die Kostenstruktur des Projekts zeigt, welcher Anteil der Kosten auf Maschinen entfällt. Bewertet wird jeder gebuchte Einsatz mit dem Einkaufspreis, der beim Speichern des Berichts festgeschrieben wurde.",
    },
  },
}
